import React from "react";
import { connect } from "react-redux";

const mapState = (state) => {
	return {
		paso: state.registro.paso,
		"dispositivo": state.global.dispositivo
	};
};

class Paso extends React.Component {

	render() {
		return (
			<div>
				{ this.props.paso < 2 &&
					<div>
					{
						<div>
                            {this.props.dispositivo==="web"?
                                <div className="txt-center">
                                    <div id="title-Registro">
                                        <label id="txt-Registro">Inconvenientes en tu registro</label>
                                        <br />
                                        <hr className="label-hr" />
                                    </div>
                                </div>: 
                            null}							
						</div>
					}
					</div>
				}
			</div>
		);
	}
}

export default connect(mapState, null)(Paso);


// WEBPACK FOOTER //
// ./src/gnp-registro-asistido/paso.cmpt.js